import axios from "axios";
import { defaultSettings } from "contexts/appsettings/defaultSettings";
import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { REACT_APP_BACKENDURL } from "../../../config";
import { getHierarchyLoaderData } from "../hierarchy/hierarchyLoader";
import { addColumnInformation } from "./addColumnInformation";
import { TlfItemReadDto } from "./TlfItemReadDto";
import { TlfLoaderData } from "./tlfLoader";

/**
 * Loader for creating a new TLF item page.
 *
 * @param props - Loader args provided by react-router
 * @param props.params - Route params used to determine new TLF type and hierarchy
 * @returns Data required to render the new TLF page
 */
export const newTlfLoader = async ({ params }: LoaderFunctionArgs) => {
  const backEndUrl = REACT_APP_BACKENDURL.includes("_REACT_APP_BACKENDURL_")
    ? defaultSettings.backEndUrl
    : REACT_APP_BACKENDURL;

  if (!params.newType) return redirect("/NotFound");

  const requests = await Promise.all([
    axios.get(`${backEndUrl}NewTlfItems/${params.newType}`),
    getHierarchyLoaderData(params),
  ]);
  const newTlfItem = requests[0]?.data as TlfItemReadDto;
  const hierarchyLoader = requests[1];

  if (!newTlfItem || !hierarchyLoader.hierarchy) return redirect("/NotFound");

  newTlfItem.azsolId = "";
  newTlfItem.primaryHierarchyId = hierarchyLoader.hierarchy.id;
  newTlfItem.primaryHierarchyName = hierarchyLoader.hierarchy.name;
  newTlfItem.primaryHierarchyLevel = hierarchyLoader.hierarchy.level;
  newTlfItem.primaryHierarchyType = hierarchyLoader.hierarchy.type;
  newTlfItem.id = params.newType;

  // Ensure columnIds and columnInformation for new TLF items
  /* istanbul ignore else */
  if ("bodyData" in newTlfItem.body && "headerData" in newTlfItem.body) {
    newTlfItem.body = addColumnInformation(newTlfItem.body);
  }

  const ret: TlfLoaderData = {
    ...hierarchyLoader,
    tlfItem: newTlfItem,
    isTlfSubscribed: false,
    isTlfNew: true,
  };
  return ret;
};
